module.exports = __webpack_public_path__ + "assets/visa.f8dc9b88.svg";